// extracted by mini-css-extract-plugin
export default {"arrow":"SelectArrow_arrow__WtGgT"};